import { useCaptureClientCallEntityInfoMutation } from '@/types/generated/graphql';
import { COOKIE_KEY } from '@shared/constants';
import Cookies from 'js-cookie';

// This api is used to capture client details for the active call, regardless of provider
export function useCaptureClientCall() {
  const sessionId = Cookies.get(COOKIE_KEY.sessionId) ?? '';
  const [captureCallInfo] = useCaptureClientCallEntityInfoMutation();

  function captureCallClientHandler(callSid: string) {
    if (!callSid || !sessionId) return;

    captureCallInfo({
      variables: {
        callSid,
        input: {
          sessionId,
        },
      },
    });
  }

  return {
    captureCallInfo: captureCallClientHandler,
  };
}
